import 'ol/ol.css'
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4.js';
import { get as getProjection } from 'ol/proj.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import TileLayer from 'ol/layer/Tile.js';
import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import { getTopLeft, getWidth } from 'ol/extent.js';

// 1. Define the EPSG:28992 projection string (Amersfoort / RD New)
proj4.defs(
  'EPSG:28992',
  '+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 ' +
  '+k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel ' +
  '+towgs84=565.4171,50.3319,465.5524,1.9342,-1.6677,9.1019,4.0725 ' +
  '+units=m +no_defs +type=crs'
);

// 2. Register proj4 within OpenLayers
register(proj4);

// 3. Fetch the projection object using getProjection
const rdProjection = getProjection('EPSG:28992');

// 4. Set the strict extent for the Netherlands RD system
const rdExtent = [-285401.92, 22598.08, 595401.92, 903401.92]; // Official matrix extent
rdProjection.setExtent(rdExtent);

// 5. Build the WMTS Tile Grid configuration required for PDOK
const resolutions = [3440.64, 1720.32, 860.16, 430.08, 215.04, 107.52, 53.76, 26.88, 13.44, 6.72, 3.36, 1.68, 0.84, 0.42, 0.21];
const matrixIds = Array.from({ length: resolutions.length }, (_, i) => `EPSG:28992:${i}`);

const tileGrid = new WMTSTileGrid({
  origin: getTopLeft(rdExtent),
  resolutions: resolutions,
  matrixIds: matrixIds,
});

import ImageLayer from 'ol/layer/Image'
import ImageWMS from 'ol/source/ImageWMS'

// 6. Initialize the map view and target layers
const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new WMTS({
        url: 'https://service.pdok.nl/kadaster/brt-achtergrondkaart/wmts/v2_0',
        layer: 'grijs',
        matrixSet: 'EPSG:28992',
        format: 'image/png',
        projection: rdProjection, // Uses your registered EPSG:28992 projection
        tileGrid: tileGrid,
        style: 'default',
      }),
    }),
    new ImageLayer({
      source: new ImageWMS({
        url: 'https://server2.brutis.nl/landsmeer.php?',
        crossOrigin: 'anonymous',
        params: { LAYERS: 'ligging,maatvoering,annotatie,inlaten' },
        projection: rdProjection // Uses your registered EPSG:28992 projection
      }),
    })
  ],
  view: new View({
    projection: rdProjection, // Forces the map view to display in EPSG:28992
    center: [122675, 493600], // Coordinates for the central point (Landsmeer)
    zoom: 8,
  }),
});

